import { Typography } from "@mui/material";
import { ArrowDropUp, Remove } from "@mui/icons-material";
import { Box } from "@mui/material";
import theme from "theme";
import { Brick } from "components/Brick";
import { Card, Row } from "v2/components/base/Flex/ui";
import { numberFormatter } from "../../utils/utils";
import { MIN_PERCENTAGE_TO_SHOW } from "../../utils/const";

export const PricePerformanceBlock = ({
  averageToFormat,
  value,
  arrowDirection,
  performance,
  ...props
}: {
  averageToFormat: number;
  value: string;
  arrowDirection: "up" | "down" | "none";
  performance: number;
} & Record<string, any>) => {
  const { sx, ...rest } = props;

  return (
    <Card.Badge
      sx={{
        color:
          averageToFormat === 0
            ? theme.palette.surface["silver"]
            : averageToFormat > 0
            ? theme.palette.system["green-alarm"]
            : theme.palette.system["red-alarm"],
        bgcolor: theme.palette.surface["container-bg"],
        border: `1px solid ${theme.palette.border.light}`,
        width: "fit-content",
        ...sx,
      }}
      {...rest}>
      <Row
        type="ec"
        sx={{
          position: "relative",
          minWidth: "52px",
          padding: "2px 2px",
        }}>
        {arrowDirection === "none" ? (
          <Remove
            sx={{
              position: "absolute",
              left: theme.spacing(-0.75),
              width: "12px",
              marginLeft: "4px",
            }}
          />
        ) : (
          <ArrowDropUp
            sx={{
              position: "absolute",
              left: theme.spacing(-0.75),
              transform: arrowDirection === "down" ? "rotate(180deg)" : "none",
            }}
          />
        )}
        <Typography
          variant="mobile-body-s-heavy"
          marginLeft={averageToFormat !== 0 ? theme.spacing(2) : 0}>
          {value}
        </Typography>
      </Row>
    </Card.Badge>
  );
};

export default PricePerformanceBlock;
